module.exports = __webpack_public_path__ + "img/success.07221e1b.svg";